import { useTranslation } from "react-i18next";

export default function Hero() {
  const { t } = useTranslation();

  const openDemo = () => {
    window.open("https://calendly.com/alex-alcalde-aidealmedia-pyr_/30min", "_blank", "noopener,noreferrer");
  };

  return (
    <section
      id="top"
      className="relative w-full min-h-[760px] md:min-h-[860px] flex items-center justify-center overflow-hidden pt-24 pb-[22vh] sm:pb-[18vh] md:pb-40"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="/img/hero-bg.jpg"
          alt="AI network background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/85 via-primary-900/75 to-primary-950/90"></div>
        <div className="absolute inset-0 grid-pattern opacity-20"></div>
      </div>

      {/* Floating orbs */}
      <div className="absolute top-24 left-[8%] w-72 h-72 rounded-full radial-glow opacity-40 animate-floaty"></div>
      <div className="absolute bottom-16 right-[6%] w-96 h-96 rounded-full radial-glow opacity-30 animate-floaty" style={{ animationDelay: "1.5s" }}></div>

      <div className="relative z-10 w-full max-w-7xl px-6 md:px-10">
        <div className="flex flex-col items-center text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-card-dark text-background-50/90 text-xs md:text-sm font-medium mb-8 animate-fadeUp">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-sparkling-2-fill text-accent-400"></i>
            </span>
            {t("hero.badge")}
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulseGlow"></span>
          </div>

          {/* Headline */}
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] max-w-5xl animate-fadeUp" style={{ animationDelay: "0.1s" }}>
            {t("hero.h1_part1")}<span className="bg-clip-text text-transparent" style={{ backgroundImage: "linear-gradient(to right, #215E88, #02B36D)" }}>{t("hero.h1_gradient")}</span>{t("hero.h1_part3")}
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-200/90 max-w-2xl leading-relaxed animate-fadeUp" style={{ animationDelay: "0.2s" }}>
            {t("hero.subtext")}
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 animate-fadeUp" style={{ animationDelay: "0.3s" }}>
            <button
              onClick={openDemo}
              className="group px-7 py-3.5 rounded-md text-sm md:text-base font-semibold text-background-50 brand-gradient-btn cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              {t("hero.cta")}
              <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                <i className="ri-arrow-right-line"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}